<template>
    <AddProfesseur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddProfesseur from "@/components/Professeur/AddProfesseur.vue";
  
    export default defineComponent({
      name: "AddProfesseurPage",
      components: {
        
        AddProfesseur,
      },
    });
  </script>